<div class="bread-crumb-container">
    <h2 class="margin-0">Search</h2>
</div>
<div class="wrapper">
    <app-grid-table></app-grid-table>
</div>
